import {toPersianNumbers} from "../../utils/toPersianNumbers";

const AttributeTable = ({ attributes, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-4 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#1E3A5F] text-[#FFC107]">
            <tr>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider">
                عنوان مشخصه
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider">
                توضیحات
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider">
                واحد اندازه‌گیری
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider">
                تعداد دسته
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider">
                عملیات
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {attributes.map((attribute) => (
              <tr key={attribute.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm font-medium text-gray-900">{attribute.name}</div>
                  <div className="text-sm text-gray-500">
                    {attribute.type === 'text' && 'متنی'}
                    {attribute.type === 'number' && 'عددی'}
                    {attribute.type === 'color' && 'رنگ'}
                    {attribute.type === 'select' && 'انتخابی'}
                    {attribute.type === 'size' && 'اندازه'}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-900 max-w-xs truncate">
                    {attribute.description || '-'}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">
                    {attribute.unit || 'بدون واحد'}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-900">
                    {toPersianNumbers(attribute.categories_count || 0)}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => onEdit(attribute)}
                      className="text-[#2196F3] hover:text-[#0C7CD5] p-1 rounded transition-colors"
                      title="ویرایش"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button
                      onClick={() => onDelete(attribute)}
                      className="text-[#E53935] hover:text-[#CB1E1A] p-1 rounded transition-colors"
                      title="حذف"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {attributes.length === 0 && (
        <div className="text-center py-12">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">مشخصه‌ای یافت نشد</h3>
          <p className="mt-1 text-sm text-gray-500">با ایجاد یک مشخصه جدید شروع کنید.</p>
        </div>
      )}
    </div>
  );
};

export default AttributeTable;